import { localStorage } from '@fiverr-private/futile';
import { BRIEF_LOCAL_STORAGE_KEY, LOGO_NAME_STEP } from './constants';

/**
 * @typedef {Object} BriefDataLogoName
 *
 * @property {String} brandName
 * @property {String} slogan
 *
 */

/**
 * @typedef {Object} BriefData
 *
 * @property {Object} brand_industry
 * @property {Object} brand_personality
 * @property {Object} logo_name
 *
 */

/**
 * Get brief stored data in storage
 * @returns {BriefData}
 */
const getBriefDataFromStorage = () => localStorage.get(BRIEF_LOCAL_STORAGE_KEY);

/**
 * Get brief logo name data from storage.
 * @returns {BriefDataLogoName}
 */
const getLogoNameDataFromStorage = () => {
    const briefData = getBriefDataFromStorage();

    return briefData && briefData[LOGO_NAME_STEP];
};

/**
 * Set brief logo name data in storage.
 * - creates data if already not created yet
 * @param {BriefDataLogoName} { brandName, slogan }
 */
const setLogoNameDataInStorage = ({ brandName, slogan }) => {
    const briefData = getBriefDataFromStorage() || {};

    localStorage.set(BRIEF_LOCAL_STORAGE_KEY, {
        ...briefData,
        [LOGO_NAME_STEP]: {
            brandName,
            slogan,
        },
    });
};

/**
 * Clears Brief runtime data
 */
const clearBriefDataFromStorage = () => {
    localStorage.remove(BRIEF_LOCAL_STORAGE_KEY);
};

export default {
    setLogoNameData: setLogoNameDataInStorage,
    getBriefLogoName: getLogoNameDataFromStorage,
    clearBrief: clearBriefDataFromStorage,
};
